


const ADMIN_EMAIL = import.meta.env?.VITE_DEMO_ADMIN_EMAIL || '';

/**
 * Returns true when debug overlays should be shown:
 *  1. URL contains ?debug=true
 *  2. Logged-in user email matches the admin email env var
 *
 * Development mode alone does NOT enable debug panels so that
 * the Rocket preview matches the real production app.
 * Admins can access debug panels via: /any-page?debug=true
 */
const useDebugMode = () => {
  // Debug panels are ONLY available in development mode.
  // They are never shown in production, staging, or demo accounts.
  if (import.meta.env?.PROD) return false;

  // In development, check for ?debug=true in the URL
  try {
    const params = new URLSearchParams(window.location?.search);
    if (params?.get('debug') === 'true') return true;
  } catch (_) {}

  return false;
};

export default useDebugMode;
